import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-best-offers',
    templateUrl: './best-offers.component.html',
    styleUrls: ['./best-offers.component.css'],
    standalone: false
})
export class BestOffersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
